import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface DealAnalysis {
  principal: number;
  interestRate: number;
  termMonths: number;

  totalEstablishmentFee: number;
  totalBrokerageFee: number;
  totalLegalCosts: number;
  totalOtherCosts: number;
  totalFeesCharged: number;

  establishmentFeeRetained: number;
  brokerageFeeRetained: number;
  referrerCommission: number;
  totalLenderRetainedFees: number;
  totalPaidOut: number;

  totalInterestIncome: number;

  totalLenderReturn: number;
  returnOnPrincipal: number;
  annualisedReturn: number;

  // Extension fields
  extensionCount: number;
  totalAdditionalMonths: number;
  originalTermMonths: number;
  totalExtensionFees: number;
  extensionFeesRetained: number;

  referrer?: {
    id: string;
    name: string;
    company?: string;
    commissionRate?: number;
  };
}

export function useDealAnalysis(loanId: string) {
  return useQuery<DealAnalysis>({
    queryKey: ['loans', loanId, 'deal-analysis'],
    queryFn: () => api.get(`/loans/${loanId}/deal-analysis`).then(r => r.data),
    enabled: !!loanId,
  });
}
